import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider, DEFAULT_THEME } from "@zendeskgarden/react-theming";
import { router } from "@/router";
import { OrderProvider } from "@/context";
import "@/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider theme={DEFAULT_THEME}>
      <OrderProvider>
        <main>
          <RouterProvider router={router} />
        </main>
      </OrderProvider>
    </ThemeProvider>
  </StrictMode>,
);
